import { Twitter, Linkedin, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import thinkrLogo from "@/assets/thinkr-logo.png";

const Footer = () => {
  return (
    <footer className="bg-background border-t border-border">
      <div className="container mx-auto px-6 py-12">
        {/* Top section with brand and links */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-8 md:gap-12 mb-8">
          {/* Brand section */}
          <div className="md:col-span-2">
            <img src={thinkrLogo} alt="thinker" className="h-6 mb-4" />
            <p className="text-sm text-muted-foreground mb-4 leading-relaxed max-w-xs">
              Empowering ecommerce business to grow profitably.
            </p>
            <Link 
              to="/contact" 
              className="inline-block px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium"
            >
              Contact
            </Link>
          </div>

          {/* Product column */}
          <div>
            <h4 className="font-semibold mb-3 text-foreground text-sm">Product</h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* Company column */}
          <div>
            <h4 className="font-semibold mb-3 text-foreground text-sm">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources column */}
          <div>
            <h4 className="font-semibold mb-3 text-foreground text-sm">Resources</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/webinars" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Webinars
                </Link>
              </li>
              <li>
                <Link to="/editorial" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Editorial
                </Link>
              </li>
              <li>
                <Link to="/audit" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Audit
                </Link>
              </li>
            </ul>
          </div>

          {/* Other column */}
          <div>
            <h4 className="font-semibold mb-3 text-foreground text-sm">Other</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom section with social and copyright */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-6 border-t border-border/50">
          {/* Social icons */}
          <div className="flex gap-4 mb-4 md:mb-0">
            <a
              href="#"
              className="text-muted-foreground hover:text-foreground transition-colors"
              aria-label="Twitter"
            >
              <Twitter size={18} />
            </a>
            <a
              href="#"
              className="text-muted-foreground hover:text-foreground transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin size={18} />
            </a>
            <a
              href="#"
              className="text-muted-foreground hover:text-foreground transition-colors"
              aria-label="YouTube"
            >
              <Youtube size={18} />
            </a>
            <a
              href="#"
              className="text-muted-foreground hover:text-foreground transition-colors"
              aria-label="TikTok"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
              </svg>
            </a>
          </div>

          {/* Copyright & Legal */}
          <div className="text-sm text-muted-foreground text-right md:text-right">
            <p>&copy; 2026 Thinkr Pro, Inc. All rights reserved.</p>
            <p>2101 Baker Street, Apt 7, San Francisco, CA 94115</p>
            <p>
              Contact: <a href="mailto:edu@thinkr.pro" className="hover:text-foreground transition-colors">edu@thinkr.pro</a> | <a href="tel:+17577074679" className="hover:text-foreground transition-colors">+1 757 707 4679</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
